export default (title, useSuffix = true) => {
  if (useSuffix) {
    title = title + ' | Pipeline'
  }

  document.title = title
}
